import wpdmIcons from "../../libs/icons";
const {registerBlockType} = wp.blocks;
const {InspectorControls, MediaUpload} = wp.editor;
const {TextControl, SelectControl, FormToggle, ServerSideRender, Modal, Button, PanelBody, IconButton} = wp.components;

const { __ } = wp.i18n;

registerBlockType('download-manager/signup-form', {
    title: 'Signup Form',

    description: 'Download Manager Sigup Form',

    keywords: [
        __( 'download manager signup form digital ecommerce store product sell' ),
        __( 'file manager' ),
        __( 'signup register form' ),
    ],

    icon: wpdmIcons.signup(),

    category: 'wpdm-blocks',

    attributes: {
        role: {
            type: 'string',
            default: 'subscriber'
        },
        logo: {
            type: 'string',
            default: ''
        },
        note_before: {
            type: 'string',
            default: ''
        },
        note_after: {
            type: 'string',
            default: ''
        },
        social_only: {
            type: 'boolean',
            default: false
        },
        className: {
            type: 'string',
            default: ''
        }
    },

    edit({attributes, className, setAttributes}) {


        function onChangeTemplate(newTemplate) {
            setAttributes({ template: newTemplate });
        }

        function onChangeID(event) {
            if (event.target.value > 0)
                setAttributes({ packageID: event.target.value });
            else if (event.target.id > 0)
                setAttributes({ packageID: event.target.id });
        }

        const captchaToggle = ncaptcha => {
            setAttributes( { captcha: ncaptcha.target.checked } );
        };

        return [

            <InspectorControls>
                <div className="w3eden">
                    <PanelBody>
                        <SelectControl
                            label="Role:"
                            help={ 'Assign signed up user to the selected role' }
                            class={"form-control wpdm-custom-select"}
                            value={ attributes.role }
                            options={ __wpdm_roles }
                            onChange={ ( role ) => { setAttributes( { role: role } ) } }
                        />


                        <div className={"form-group"}>
                            <FormToggle
                                id={"soconly"}
                                checked={attributes.social_only}
                                onChange={_social_only => {
                                    setAttributes({social_only: _social_only.target.checked});
                                }}
                            />
                            <label htmlFor={"soconly"} style={{paddingLeft: "5px"}}> Social Signup Only</label>
                        </div>

                    </PanelBody>
                    <PanelBody title={__('Notes')}>
                        <TextControl
                            label="Before Form:"
                            help={ 'Write if you have any special instructions' }
                            value={ attributes.note_before }
                            onChange={ ( note_before ) => setAttributes( { note_before: note_before } ) }
                        />
                        <TextControl
                            label="After Form:"
                            help={ 'Write if you have any special instructions' }
                            value={ attributes.note_after }
                            onChange={ ( note_after ) => setAttributes( { note_after: note_after } ) }
                        />
                    </PanelBody>
                    <PanelBody title={__('Logo:')}>
                        <MediaUpload
                            onSelect={  img => {
                                setAttributes( {
                                    logo: img.url
                                } )} }
                            type="image"
                            value={ attributes.logo }
                            render={ ( { open } ) => (
                                <div>
                                    <IconButton
                                        className="ab-cta-inspector-media"
                                        label={ __( 'Edit image' ) }
                                        icon="format-image"
                                        onClick={ open }
                                    >
                                        { __( 'Select Image' ) }
                                    </IconButton>

                                    { attributes.logo && !! attributes.logo.length && (
                                        <div>
                                            <img style={{margin: "10px 0", height: "128px", width: 'auto'}} src={attributes.logo} />
                                        <IconButton
                                            className="ab-cta-inspector-media"
                                            label={ __( 'Remove Image' ) }
                                            icon="dismiss"
                                            onClick={ () => {
                                                setAttributes({
                                                    logo: ''
                                                })
                                            } }
                                        >
                                            { __( 'Remove' ) }
                                        </IconButton>
                                        </div>
                                    ) }
                                </div>
                            ) }
                        >
                        </MediaUpload>
                    </PanelBody>
                </div>
            </InspectorControls>
            ,
            <ServerSideRender
                block={"download-manager/signup-form"}
                attributes = {attributes}
                />
            ];
    },
    save() {
        return null;
    }
});
